export enum CbhFeatureFlag {
  WORKPLACE_REFERRALS = "2023-10-facilitate-rollout-workplace-referrals",
  HOME_HEALTH_ENABLED = "2024-01-home-health-HCF-HHA-enabled",
  INVOICE_HISTORY_REVAMP = "2024-02-alchemy-release-invoice-history-revamp",
  HOME_HEALTH_PAY_RATES = "2024-03-home-health-default-pay-rates-per-visit-type",
  INVOICE_DISPUTE_PAGE = "2024-03-alchemy-release-invoice-dispute-page",
  STREAKS_PRE_REWARD = "2024-03-core-services-streaks-pre-rewards",
  HOME_HEALTH_WORKER_CHAT_ENABLED = "2024-03-home-health-worker-chat-enabled",
  HOME_HEALTH_FOOTER_URLS = "2024-05-home-health-hcf-footer-urls",
  HOME_HEALTH_BONUS_PAYMENT = "2024-05-home-health-bonus-payment",
  HCP_SOFT_DELETION = "2024-06-sparta-rollout-hcp-soft-deletion",
  SHOW_SHIFT_BLOCK_LABEL_ALTERNATE_COPY = "2024-06-facilitate-show-shift-block-label-alternate-copy",
  MAGIC_POINTS = "2024-06-core-services-magic-points",
  SHOW_AVAILABLE_WORKERS_CONFIG = "notify-available-workers-about-shift-creation",
}
